module.exports = __webpack_public_path__ + "static-portal/img/bg.c944cfb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/welcome/bg.jpg
// module id = jolG
// module chunks = 4